export default __webpack_public_path__ + "static/media/van.b61d1dd4.png";